module.exports = __webpack_public_path__ + "img/3.1910dae6.png";